import React, { Component } from "react";
import ChooseField from "./Pages/ChooseField";
import { Route, Switch } from "react-router-dom";
import EditField from "./Pages/EditField";
import { GlobalStyle } from "./theme/global";
import { IntlProvider } from "react-intl";
import messages_pl from "./translations/pl";
import messages_en from "./translations/en";
import { connect } from "react-redux";
import { LANGUAGES } from "./constants";
import { LanguageSwitcher } from "./theme/styled";

const messages = {
  pl: messages_pl,
  en: messages_en,
};

class App extends Component {
  componentDidMount() {
    const language = navigator.language.split(/[-_]/)[0]; // language without region code
    this.props.dispatch.ui.setLanguage(language);
  }
  render() {
    const { language, dispatch } = this.props;
    return (
      <IntlProvider
        locale={language}
        messages={messages[language]}
        key={language}
      >
        <>
          <LanguageSwitcher>
            <button
              className="pl"
              onClick={() => dispatch.ui.setLanguage(LANGUAGES.pl)}
            >
              PL
            </button>
            <button
              className="en"
              onClick={() => dispatch.ui.setLanguage(LANGUAGES.en)}
            >
              EN
            </button>
          </LanguageSwitcher>
          <Switch>
            <Route path="/edit" component={EditField} />
            <Route component={ChooseField} />
          </Switch>
          <GlobalStyle />
        </>
      </IntlProvider>
    );
  }
}
const mapState = ({ ui: { language } }) => ({ language });
App = connect(mapState)(App);
export default App;
